// components/LanguageSection.jsx
import React, { useState } from "react";
import LanguageIcon from "@mui/icons-material/Language";
import { Reveal, useTyping } from "../lib/hooks";
import { TYPING_PROMPTS } from "../lib/data";

// const LANGS = ["हिंदी", "தமிழ்", "తెలుగు", "ਪੰਜਾਬੀ", "বাংলা", "ಕನ್ನಡ", "मराठी", "English"];
const LANGS = [];

const RESULTS = [
  // { name: "Celebration Rush",  desc: "Sensacion · Festive Indian pop", bpm: "118 BPM", grad: "from-pink to-navy" },
  // { name: "Trailer Hits",      desc: "Gothic Storm · Monster trailers", bpm: "124 BPM", grad: "from-[#c9922a] to-[#0f6e56]" },
  // { name: "Festive Dhol",      desc: "Silk Road · Indian percussion",   bpm: "132 BPM", grad: "from-[#534ab7] to-pink" },
];

export default function LanguageSection() {
  const [activeLang, setActiveLang] = useState(0);
  const typedText = useTyping(TYPING_PROMPTS);

  return (
    <section className="bg-[#f4f6fb] dark:bg-[#161b22] relative overflow-hidden" style={{background : "rgb(var(--canvas))"}}>
      <div className="section-inner">
        <div className="grid lg:grid-cols-2 gap-6 items-center sm:grid-cols-1">

          {/* Left */}
          <Reveal direction="left">
            <div className="section-label">Indian Languages</div>
            <h2 className="section-title">
              Search in<br />your mother tongue.
            </h2>
            <p className="pricing-sub-header mb-4">
              Searching the right track has never felt more natural. No more "dramatic orchestral"; just describe exactly your brief, or the context, to MAYA in your mother tongue. AI isn’t here to replace human creativity, it’s here to amplify it. 
            </p>
            {LANGS?.length > 0 &&
            <div className="flex flex-wrap gap-2.5">
              {LANGS.map((lang, i) => (
                <button
                  key={lang}
                  onClick={() => setActiveLang(i)}
                  className={`
                    px-6 py-2 rounded-full text-sm font-medium font-dm
                    border cursor-pointer transition-all duration-250 lic-pill
                  `}
                >
                  {lang}
                </button>
              ))}
            </div>}
          </Reveal>

          {/* Right — Prompt mockup */}
          <Reveal direction="right">
            <div className="lic-card">
              {/* Title bar */}
              <div className="flex items-center gap-1.5 px-4 py-3 bg-[rgba(27,58,107,0.03)] dark:bg-[rgba(255,255,255,0.03)] border-b border-[rgba(27,58,107,0.08)] dark:border-[rgba(255,255,255,0.06)]">
                {["#ff5f56", "#ffbd2e", "#0a9e78"].map((c, i) => (
                  <span key={i} className="w-2.5 h-2.5 rounded-full" style={{ background: c }} />
                ))}
                <span className="ml-2 lic-step-desc">AI Prompt Search</span>
              </div>
              {/* Search row */}
              <div className="flex items-center gap-2.5 px-4 py-3.5 border-b border-[rgba(27,58,107,0.08)] dark:border-[rgba(255,255,255,0.06)] bg-[rgba(233,30,140,0.02)]">
                <LanguageIcon sx={{ fontSize: 20, color: "#8899bb" }} />
                <span className="text-md navy-text font-dm">
                  {typedText}
                  <span className="inline-block w-0.5 h-8 bg-pink-100 ml-px align-middle animate-cursor-blink" />
                </span>
              </div>
              {/* Results */}
              {RESULTS?.length > 0 &&
              <div className="py-2">
                {RESULTS?.map((r, i) => (
                  <div key={i} className="flex items-center gap-3 px-4 py-2.5 hover:bg-[rgba(27,58,107,0.04)] dark:hover:bg-[rgba(255,255,255,0.04)] transition-colors">
                    <div className="w-16 h-16 rounded-md flex-shrink-0 bg-gradient-to-br from-blue-900 to-pink-500" />
                    <div>
                      <div className="text-sm font-semibold navy-text dark:text-[#e6edf3]">{r.name}</div>
                      <div className="text-sm navy-text-1 text-[#5a6888] dark:text-[#8b949e]">{r.desc}</div>
                    </div>
                    <div className="ml-auto font-mono text-xs navy-text-1 flex-shrink-0">{r.bpm}</div>
                  </div>
                ))}
              </div>}
            </div>
          </Reveal>

        </div>
      </div>
    </section>
  );
}
